import { companyStore } from "../stores";

export const useCompanyStore = () => companyStore;
